module.exports = __webpack_public_path__ + "static/media/ajax.4b853e02.png";